import React, { useEffect, useState } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import IconOne from "../assets/images/totalcustomers.svg";
import IconTwo from "../assets/images/totaldrivers.svg";
import IconThree from "../assets/images/totalorders.svg";
import { get, post } from "../utils/helpers/http";
import Bag from "../assets/images/lbag.png"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLocalStorageData} from "../utils/helpers/helpers";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [detail, setDetails] = useState();
  const [outOfStock, setOutOfStock] = useState(false);
  const [bagsQuantity, setBagsQuantity] = useState("");
  const [disableAddButton, setDisableAddButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getLocalStorageData("authorizationToken")) {
      details();
      const storedOutOfStock = getLocalStorageData("outOfStock");
      if (storedOutOfStock) {
        setOutOfStock(storedOutOfStock === "true");
      }
    } else {
      navigate("/");
    }
  }, []);

  const details = async () => {
    let reqBody = {}
    const response = await get('/Dashboard/GetDashboardDetails', reqBody)
    setDetails(response.data)
  }

  // const handleCheckboxChange = async (event) => {
  //   const isChecked = event.target.checked;
  //   setOutOfStock(isChecked);
  //   setLocalStorageData("outOfStock", isChecked.toString());
  //   try {
  //     await post('/Dashboard/UpdateBagStockStatus', { outOfStock: isChecked });
  //   } catch (error) {
  //   }
  // };

  const handleBagsQuantityChange = (event) => {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length  > 5) {
      value = value.slice(0, 5); 
    }
    setBagsQuantity(value);
  };

  const handleAddButtonClick = async () => {
    if (bagsQuantity === '0') {
      toast.error("0 value cannot be added");
      return;
    }
    if (!bagsQuantity) {
      toast.error("Bags quantity cannot be empty");
      return;
    }
    try {
      const reqBody = {
        transType: 1,
        qty: bagsQuantity,
      };
      await post('/Dashboard/AddUpdateBagStockTransaction', reqBody);
      details();
      toast.success("Bag(s) added successfully");
    } catch (error) {
    }
  };

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Dashboard</h1>
                </div>
              </div>
              <div className="page-content">
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="dash-card cardOne mb-3">
                      <a href="/customers" className="overlayanchor">
                        &nbsp;
                      </a>
                      <div className="card-icon mt-3">
                        <img src={IconOne} alt="icon" />
                      </div>
                      <h2 className="mt-2">{detail?.totalCustomer || 0}</h2>
                      <h5 className="mt-2">Total Customers</h5>
                      <div className="moreinfotext mt-3">More Info</div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="dash-card cardTwo mb-3">
                      <a href="/manage-drivers" className="overlayanchor">
                        &nbsp;
                      </a>
                      <div className="card-icon mt-3">
                        <img src={IconTwo} alt="icon" />
                      </div>
                      <h2 className="mt-2">{detail?.totalDriver || 0}</h2>
                      <h5 className="mt-2">Total Drivers</h5>
                      <div className="moreinfotext mt-3">More Info</div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="dash-card cardThree mb-3">
                      <a href="/manage-orders" className="overlayanchor">
                        &nbsp;
                      </a>
                      <div className="card-icon mt-3">
                        <img src={IconThree} alt="icon" />
                      </div>
                      <h2 className="mt-2">{detail?.totalOrder || 0}</h2>
                      <h5 className="mt-2">Total Orders</h5>
                      <div className="moreinfotext mt-3">More Info</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-5 col-xl-6 col-lg-9">
                    <div className="lbag">
                      <div className="lbagTop d-flex align-items-center flex-wrap mb-3">
                        <div>
                          <img
                            src={Bag}
                            alt="icon"
                          />
                        </div>
                        <h2 className="m-3">{detail?.restBags || 0}/{detail?.totalBags || 0}</h2>
                        <h5>Total Laundry Bags</h5>
                      </div>
                      <div className="lbagadd d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center flex-wrap mt-2 mb-2">
                          <label>Bags</label>
                          <div className="ms-2 me-2">
                            <input
                              type="text"
                              placeholder="Bags quantity"
                              className="form-control"
                              style={{ width: "140px" }}
                              value={bagsQuantity}
                              onChange={handleBagsQuantityChange}
                            />
                          </div>
                          <button
                            id="addButton"
                            className="btn btn-primary"
                            onClick={handleAddButtonClick}
                            disabled={disableAddButton}
                          >
                            Add
                          </button>
                        </div>
                        {/* <div className="checkbox">
                          <input
                            type="checkbox"
                            id="outofstock"
                            checked={outOfStock}
                            onChange={handleCheckboxChange}
                          />
                          <label htmlFor="outofstock">Out of Stock</label>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ToastContainer
  position="top-right"
  autoClose={5000}
  hideProgressBar={false}
  closeOnClick
  pauseOnHover
  draggable
  onOpen={() => {
    setDisableAddButton(true);
    setTimeout(() => {
      setDisableAddButton(false);
    }, 5000);
  }}
/>

          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
